module.exports = __webpack_public_path__ + "media/General_FunnelPirata_20200507.bcdd17f9.mp4";